// v49.45 — useBreakpoint hook.
// 3-tier breakpoint detection used by ShellLayout to switch between
// the mobile app-shaped chrome (slim top header + bottom tab nav +
// FAB) and the desktop sidebar+topbar shell.
//
// Boundaries mirror v48.32:
//   mobile  : viewport < 640px (Tailwind 'sm' / iPhone Pro Max-ish)
//   tablet  : 640–1023px (iPad portrait + landscape phones)
//   desktop : ≥ 1024px (laptops and up)

import { useEffect, useState } from "react";

export type Breakpoint = "mobile" | "tablet" | "desktop";

function resolve(): Breakpoint {
  if (typeof window === "undefined" || !window.matchMedia) return "desktop";
  if (window.matchMedia("(max-width: 639px)").matches) return "mobile";
  if (window.matchMedia("(min-width: 1024px)").matches) return "desktop";
  return "tablet";
}

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(resolve);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mqMobile  = window.matchMedia("(max-width: 639px)");
    const mqDesktop = window.matchMedia("(min-width: 1024px)");
    const onChange = () => setBp(resolve());
    const add = (mq: MediaQueryList) => {
      if (mq.addEventListener) mq.addEventListener("change", onChange);
      else mq.addListener(onChange);
    };
    const remove = (mq: MediaQueryList) => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
    add(mqMobile); add(mqDesktop);
    return () => { remove(mqMobile); remove(mqDesktop); };
  }, []);

  return bp;
}
